import { Form, message, Row } from 'antd';
import React, { useEffect, useReducer, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import ApiErrorComp from './ApiErrorComp/ApiErrorComp';
import liracrypt from './Liracrypt/liracrypt';
import ZenFormInput from '../pages/InputCreater/ZenFormInput';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import queryString from 'query-string';
import Scanter from './STORM/Scanter';
const initialState = {
    response: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case "setResponse":
            return {
                ...state,
                response: action.payload
            };
        default:
            return state;
    }

}
const ZenMultiScanter = ({
    api = '/textapi',
    urlData,
    method = 'GET',
    scanterCallback
}) => {
    const [form] = Form.useForm();
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const LocalDict = [];
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];

    const [pageData, dispatch] = useReducer(reducer, initialState);
    const [loading, setLoading] = React.useState(false);
    const [barCodeData, setBarCodeData] = useState([]);
    const scanter = {
        "buttonProp": {
            "type": "primary",
            "label": "Scan Here",
            "visible": true,
            "enable": true,
            "validateFields": false,
            "confirmationPopUp": false,
            "submitFormData": true,
            "popUpModal": false,
            "postSubmitAction": false
        },
        "confirmationPopUpProp": {
            "text": "Do you want to refresh the screen?",
            "okButtonLabel": "Yes",
            "cancelButtonLabel": "Cancel"
        },
        "submitFormDataProp": {
            "method": "POST",
            "url": "/tempstableButtonCall",
            "params": {
                "param1": "p1",
                "param2": "p2"
            }
        },
        "validateFieldsProp": {
            "validList": {
                "enable": false,
                "criteria": [
                    "test1",
                    "test2",
                    "test3",
                    "test4"
                ],
                "msg": "Item Not in Valid List"
            },
            "lengthOfString": {
                "enable": false,
                "criteria": [
                    3,
                    5,
                    4,
                    10
                ],
                "msg": "Invalid Length of Scanned textsdfasdfsa"
            },
            "prefix": {
                "enable": false,
                "criteria": [
                    "tg",
                    "ty",
                    "te"
                ],
                "msg": "Invalid Prefix of sdfsd Scanned text"
            }
        },
        "postSubmitActionProp": {
            "test1": {
                "typ": "route",
                "route": "/lineperformance",
                "params": { "ABx": "Cdfd" }
            },
            "test2": {
                "typ": "route",
                "route": "/lineperformance",
                "params": { "ABx": "Cdfd" }
            },
            "test3": {
                "typ": "route",
                "route": "/lineperformance",
                "params": { "ABx": "Cdfd" }
            },
            "test4": {
                "typ": "smodal",
                "api": "/smodal",
                "params": { "ABx": "Cdfd", "dictName": "SmtLoaderInfo" }
            },
        },
    }

    const queryElements = (controls) => {
        return (
            <Row justify={"space-between"}>
                {
                    controls.map((data, index) => {
                        if (dtArray.includes(data["typ"])) {

                            LocalDict[data["data_index"]] = data["format"]
                                ? data["format"]
                                : "YYYY-MM-DD hh:mm:ss";
                            LocalDict["data_index_from"] = data["data_index_from"];
                            LocalDict["data_index_to"] = data["data_index_to"];
                        }

                        if (data.visible) {
                            return (
                                <React.Fragment key={index}>
                                    <ZenFormInput
                                        //    urlData={{ ...urlData }}
                                        childType={data.childType}
                                        pageType={"zenForm"}
                                        header={data.header}
                                        footer={data.footer}
                                        labelColSpan={data["labelColSpan"]}
                                        style={data['style']}
                                        height={data['height']}
                                        layoutPosition="space-between"
                                        form={form}
                                        LocalDict={LocalDict}
                                        rows={data.rows}
                                        colSpan={data.colSize || 12}
                                        name={data["data_index"]}
                                        label={data["label"]}
                                        defaultValue={data["default"]}
                                        typ={data["typ"]}
                                        disabled={data["readOnly"]}
                                        source={data["source"]}
                                        sourceParams={data["sourceParams"]}
                                        auxParams={data["auxParams"]}
                                        format={data["format"]}
                                        errorMessage={data["errorMessage"]}
                                        placeHolder={data["placeHolder"]}
                                        required={data["required"]}
                                        options={data["data"]}
                                        from={data["data_index_from"]}
                                        to={data["data_index_to"]}
                                        url={data["url"]}
                                        includeAll={data["includeAll"]}
                                        pname={data["p_data_index"]}
                                        defaultFrom={data["defaultFrom"]}
                                        defaultTo={data["defaultTo"]}
                                        multiSelect={data["multiSelect"]}
                                        searchable={data["isSearchable"]}
                                        data={data}
                                        //   extraData={extraData}
                                        children={data['children']}
                                    />
                                </React.Fragment>
                            );
                        }
                    })}
            </Row>)
    }

    const checkMrplCode = (barCode) => {
        let count = barCode.split('$').length - 1;
        if (count >= 2) return true;
        return false;
    }

    const onScanterFinish = async (values) => {
        let hasMrplCode = false;
        let firstBarCode = barCodeData[0] || '';
        let scannedCode = values.barCode;
        if (checkMrplCode(firstBarCode)) {
            hasMrplCode = true;
            if (checkMrplCode(scannedCode)) {
                message.error('Please scan a different barcode!');
                return;
            }
        }

        if (barCodeData.length === 1) {
            if (!checkMrplCode(scannedCode) && !hasMrplCode) {
                message.error('Please scan mrpl barcode!');
                return;
            } else {
                setBarCodeData([...barCodeData, scannedCode]);
                let response;
                if (method === 'POST') {
                    response = await liracrypt.post(api, { ...searchParams, ...urlData, barCodes: [...barCodeData, scannedCode] });
                };
                if (method === 'PATCH') {
                    response = await liracrypt.patch(api, { ...searchParams, ...urlData, barCodes: [...barCodeData, scannedCode] });
                };
                if (method === 'GET') {
                    response = await liracrypt.get(api, { ...searchParams, ...urlData, barCodes: [...barCodeData, scannedCode] });
                };
                try {
                    if (response.data.isSuccess) {
                        message.success(response.data.message || 'Scanned successfully!');
                        dispatch({
                            type: "setResponse", payload: response.data.data
                        });
                        setLoading(false);
                        scanterCallback();
                    }
                    else {
                        message.error(response.data.message || 'Something went wrong!');
                    }
                } catch (error) {
                    console.error(error);
                    ApiErrorComp();
                }
            }
        }
        setBarCodeData([...barCodeData, scannedCode]);

    }

    return (
        <div className="zenpop-scanter">
            {
                loading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <LoadingOutlined
                        style={{ fontSize: 80, color: "#007bff" }}
                        spin
                    /></div> :
                    <>
                        <Scanter
                            id="zen-multi-scanter"
                            onFinish={onScanterFinish}
                            postSubmitAction={() => { }}
                            openPopupModal={() => { }}
                            button={scanter}
                            // setSelectedButton={setSelectedButton}
                            form={null}
                            label={scanter?.buttonProp?.label}
                            type={scanter?.buttonProp?.type}
                            disabled={!scanter?.buttonProp?.enable}
                            confirmationPopUp={scanter?.buttonProp?.confirmationPopUp ? scanter?.confirmationPopUpProp : undefined}
                            submitFormData={scanter?.submitFormDataProp}
                        />
                        {
                            barCodeData.length ? (
                                <div className='scanter-data'>
                                    <h1 style={{ color: '#ffffff' }}>Scanned Barcodes:</h1>
                                    {
                                        barCodeData.map((data, index) => (
                                            <p key={`barcode-${index}`}>
                                                <span style={{ fontSize: 22, color: '#ffffff' }}>
                                                    {(checkMrplCode(data)) ? "MRPL BarCode" : 'Vendor BarCode'} :
                                                </span> <span style={{ fontSize: 25, color: '#ffffff' }}>{data}</span>
                                            </p>
                                        ))
                                    }
                                </div>
                            ) : null
                        }
                        {
                            pageData.response ?
                                <div>
                                    {queryElements(pageData.response)}
                                </div> :
                                null
                        }

                        {/* {queryElements(pageData.barCodes)} */}


                    </>
            }

        </div>
    )
};

export default ZenMultiScanter;